import axios, {
  AxiosError,
  HttpStatusCode,
  InternalAxiosRequestConfig
} from "axios";
// import { removePaymentMethod } from "../redux/Slice/AppSlice";
// import { setLogin, setLogout } from "../redux/Slice/AuthSlice";
// import { clearCart } from "../redux/Slice/CartSlice";
// import { store } from "../redux/Store/configureStores";
import { showErrorToast } from "../components/Toast";
import { store } from "../store";
import { setLogout } from "../store/slices/authSlice";


const { dispatch, getState} = store


// console log for init
console.log("Initializing axios...");
// const { dispatch, getState } = store;
// const dispatch = hooks.useDispatch();

export interface ApiResponse<T = any> {
 data: T | null;
 error: Record<string, string> | string | null;
 errorData?: any;
}

// defaults
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
console.log(`Axios Api Url: ${process.env.REACT_APP_API_BASE_URL}`);


// request interceptor
axios.interceptors.request.use(
 async (config: InternalAxiosRequestConfig) => {
   const { authReducer } = getState();
   let token = authReducer?.auth?.token || "";

   // headers
   config.headers["Accept"] = "application/json";
   config.headers["Content-Type"] = "application/json";
   config.headers["orderKey"] = "App";
   config.headers["v"] = "1.0.0";
   if (token) {
     config.headers["Authorization"] = `Bearer ${token}`;
   }
   return config;
 },
 (error: AxiosError) => {
   console.error("Request error:", JSON.stringify(error));
   return Promise.reject(error);
 }
);


// response interceptor
axios.interceptors.response.use(
 async (response): Promise<any> => {
   return { data: response.data.data, error: null };
 },
 async (error: AxiosError): Promise<any> => {
   const originalRequest = error.config as any;


   if (error?.response) {
     const defaultErrorMessage =
       "Oops something went wrong! Please try again later.";
     const { status, data } = error.response;


     if (
       status === HttpStatusCode.UnprocessableEntity ||
       status === HttpStatusCode.BadRequest
     ) {
       const { errors } = data as any;
       return {
         data: null,
         error: formatValidationError(errors),
         errorData: (data as any)?.data ?? null,
       };
     } else if (status === HttpStatusCode.InternalServerError) {
       return showErrorToast(defaultErrorMessage);
     } else if (status === HttpStatusCode.Unauthorized && !originalRequest._retry) {
       originalRequest._retry = true;
       const isTokenUpdated = await refreshTokens();
       if (isTokenUpdated) {
         return await axios(originalRequest);
       } else {
         dispatch(setLogout());
         showErrorToast(defaultErrorMessage);
         return { data: null, error: defaultErrorMessage };
       }
     } else if (status === HttpStatusCode.Forbidden) {
       dispatch(setLogout());
      //  dispatch(clearCart());
      //  dispatch(removePaymentMethod());
       return { data: null, error: "Please login again to proceed." };
     } else {
       const { errors } = data as any
       console.log(errors)
       showErrorToast(errors[0]?.msg  || defaultErrorMessage);
       return {
         data: null,
         error: formatValidationError(errors) || defaultErrorMessage,
       };
     }
   }


   return { data: null, error: "Network error" };
 }
);




// refresh token
async function refreshTokens(): Promise<boolean> {
 const { authReducer } =getState();
 const sessionToken = authReducer?.auth?.token;
 const refreshToken = authReducer?.auth?.refreshToken;
 const user = authReducer?.auth?.user;


 if (!sessionToken || !refreshToken || !user) {
   return false;
 }

 // Example flow (commented out in your code):
 // const { data } = await apiService.authRenewTokenApiAsync({ phone, refreshToken });
 // if (data && data.token) {
 //   const decodedUser = jwtDecode(data.token.session);
 //   dispatch(setLogin({ user: decodedUser, token: data.token.session }));
 //   return true;
 // }


 return false;
}


// validation error formatter
const formatValidationError = (
 errors: Array<{ param: string | null; msg: string }>
): Record<string, string> => {
 const validationErrors: Record<string, string> = {};
 errors.forEach((err) => {
   if (err.param !== null) {
     validationErrors[err.param] = err.msg;
   }
 });
 return validationErrors;
};


console.log("Initializing axios... done");